import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import Utilities from '../../common/utilities'
import SkillList from '../../skill/list'


class ProfileMain extends React.Component {
  render() {
    return (
      <div className="profile-header row">
        <div className="col-lg-2 col-md-4 col-sm-12 text-center">
          <img src="/images/default_emp_profile.jpg"  className="header-avatar" />
        </div>
        <div className="col-lg-5 col-md-8 col-sm-12 profile-info">
          <div className="header-fullname">{this.props.employee.name}</div>
         
          <div>{Utilities.toTitleCase (this.props.job_title)}</div>
          <div className="header-information">
            Working at <span className=" electric-blue">{ this.props.workinfo.working_at ? this.props.workinfo.working_at : '--'}</span>, 
            as <span className=" pink">{ this.props.workinfo.working_as ? this.props.workinfo.working_as : '--'}</span>
            <div>{this.props.skills.length > 0 ? 'Skills :' : ''} 
              {this.props.skills.map(function(skill) {
              return <SkillList key={skill} name={skill}  />
             }.bind(this))}
            </div>
            <div style={{ color: "#bbbaba" }}>Last Updated On: {Utilities.format_date(this.props.employee.updated_at)}</div>
          </div>
        </div>
        <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12 profile-stats">
          <div className="row">
            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12 stats-col">
              <div className=" text-success">{this.props.employee.ikama_number}&nbsp;</div>
              <div className="stats-title">ID# / IQAMA</div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12 stats-col">
              <div className=" text-success">{this.props.employee.passport_number}</div>
              <div className="stats-title">PASSPORT</div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12 stats-col">
              <div className=" text-success">{this.props.employee.visa_number}&nbsp;</div>
              <div className="stats-title">VISA</div>
            </div>
          </div>
          <div className="row m-t-20">
            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 inlinestats-col">
              <i className="fa fa-calendar" /> Joined On
              <div className=" electric-blue">{this.props.employee.joining_date}</div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 inlinestats-col">
              <i className="fa fa-birthday-cake" /> Age
              <div className=" electric-blue">{this.props.employee_age}</div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 inlinestats-col">
              <i className="fa fa-money" /> Basic
              <div className=" electric-blue">{this.props.workinfo.current_rate}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default ProfileMain